import React from "react";
import { QueryCache } from "react-query";
import { WidgetPage } from "../../widgets";
import { DefaultHero } from "@ecologi/react-components/src/DefaultHero";
import { dehydrate } from "react-query/hydration";
import { getWPData, getTotals, REBUILD_TIMEOUT } from "../../lib";
import { Wordpress } from "@ecologi/shared";

const businessPageUrls = [
  "/business/view",
  "/business/solutions",
  "/business/ecologi-zero-roadmap",
];

export default function Page(props) {
  // Temp while we figure out what the url structure is
  const isNewBusinessPage = businessPageUrls.some((value) =>
    props.data.link.includes(value)
  );
  const hero = isNewBusinessPage ? undefined : <DefaultHero {...props} />;
  return <WidgetPage header={hero} {...props} />;
}

export async function getStaticProps({ params }) {
  const data = await getWPData(`business/?slug=${params.slug}`, true);

  if (!data) {
    return {
      notFound: true,
    };
  }

  const queryCache = new QueryCache();
  await queryCache.prefetchQuery("totals", getTotals);

  return {
    revalidate: REBUILD_TIMEOUT,
    props: {
      data,
      dehydratedState: dehydrate(queryCache),
      layoutProps: {
        isLightHeader: true,
        isWhiteBody: true,
        navColour: data?.acf.nav_colour || "transparent",
      },
    },
  };
}

export async function getStaticPaths() {
  let data = [];
  let pageNumber = 1;

  // WP data can be huge, so chunk instead of fetching all at once
  while (true) {
    const res = await getWPData(
      `business?per_page=${Wordpress.WORDPRESS_FETCH_PER_PAGE}&page=${pageNumber}&_fields=slug`
    );

    if (!Array.isArray(res)) break;

    data = [...res, ...data];
    pageNumber++;

    console.log(`Waiting on page ${pageNumber} for 'business/[slug]'...`);
    await new Promise((res) => setTimeout(res, 2e3)); // don't DOS the site
  }

  data.sort((a, b) => (a.date_gmt > b.date_gmt ? -1 : 1));

  return {
    paths: data.map(({ slug }) => `/business/${slug}`) || [],
    fallback: "blocking",
  };
}
